import { Action } from 'redux';

import { SetContentExplorerToolbarState } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';

import { ContentExplorerToolbarState } from '../state/ContentExplorerState';

export interface SetContentExplorerToolbarStateAction extends Action {
    readonly state: ContentExplorerToolbarState;
}

export function setContentExplorerToolbarState(state: ContentExplorerToolbarState): SetContentExplorerToolbarStateAction {
    return {
        type: SetContentExplorerToolbarState,
        state,
    };
}

export const isSetContentExplorerToolbarStateAction = isActionFactory<SetContentExplorerToolbarStateAction>(SetContentExplorerToolbarState);